import React from 'react';
import PropTypes from 'prop-types';
import { withAuthenticationRequired } from '@statsbomb/kitbag-auth';
import { Loader } from '@statsbomb/kitbag-components';

export const ProtectedRoute = ({ component = null }) => {
  const Component = withAuthenticationRequired(component, {
    onRedirecting: () => <Loader />,
  });

  return <Component />;
};

ProtectedRoute.propTypes = {
  component: PropTypes.func,
};

export default { ProtectedRoute };
